import ProfileTabEmptyState from "./profile-tab-empty-state";

const ProfileCoachingEmptyState = () => (
  <div className="w-full bg-white min-h-full">
    <div className="flex flex-col gap-6">
      <div className="flex items-start justify-between pt-2">
        <h1 className="text-lg font-semibold text-gray-900">Coaching Report</h1>
      </div>
      <ProfileTabEmptyState
        title="No Insights Yet"
        body="Coaching insights will show up here once you've had a few 1-on-1s together."
      />
    </div>
  </div>
);

export default ProfileCoachingEmptyState;
